import styled from "@emotion/styled";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { Typography, Link } from "@kaltura/ds-react-components";
import { Info24Icon } from "@kaltura/ds-react-icons";

interface UploadErrorIndicatorProps {
    onClick: () => void;
}

const StyledContainer = styled("div")(({ theme }) => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    textAlign: "center",
    backgroundColor: theme.kaltura.palette.danger.main,
    color: theme.kaltura.palette.danger.contrastText,
    borderRadius: theme.kaltura.shape.roundness2,
}));

const StyledInfo24Icon = styled(Info24Icon)({
    width: 30,
    height: 30,
});

const StyledLink = styled(Link)(({ theme }) => ({
    color: theme.kaltura.palette.danger.contrastText,
    textDecorationColor: theme.kaltura.palette.danger.contrastText,
}));

/**
 * in place uploader error indicator
 */
export const UploadErrorIndicator = ({ onClick }: UploadErrorIndicatorProps) => {
    return (
        <StyledContainer>
            <StyledInfo24Icon />
            <Typography variant={"h5"} component="div">
                {translate("Upload Failed")}
            </Typography>
            <StyledLink component="button" type="button" onClick={onClick}>
                {translate("Try again")}
            </StyledLink>
        </StyledContainer>
    );
};
